import { useUser } from 'entities/user/react';
import { useTranslation } from 'react-i18next';
import { useShowNotification } from 'shared/hooks/notification/use-show-notification';
import {
  useDeleteDocument as useApiDeleteDocument,
  useDeleteDocuments as useApiDeleteDocuments,
} from '../api';

/**
 * Hook pozwalający na usunięcie dokumentu.
 */
export const useDeleteDocument = () => {
  const showNotification = useShowNotification();
  const { mutateAsync: _deleteOne } = useApiDeleteDocument();
  const { mutateAsync: _deleteMany } = useApiDeleteDocuments();
  const { t } = useTranslation('document-delete');
  const { data: user } = useUser();

  /**
   * Usuwanie przekazanego dokumentu
   */
  const deleteDocument = async (ids: number | number[]) => {
    const count = Array.isArray(ids) ? ids.length : 1;

    if (!user) {
      throw new Error('User is not logged in');
    }

    try {
      if (!Array.isArray(ids)) {
        await _deleteOne({ documentId: ids });
      } else {
        await _deleteMany({ ids, boardId: user.lastBoard.id });
      }

      showNotification({
        message: t('notification.success', { count }),
        variant: 'success',
      });
    } catch (e) {
      showNotification({
        message: t('notification.error', { count }),
        variant: 'error',
      });

      throw e;
    }
  };

  return {
    deleteDocument,
  };
};
